import type { FilterOption } from '../types';

const sortCheckboxOptions = (optionA: FilterOption, optionB: FilterOption) => {
  if (typeof optionA.order !== 'undefined' && typeof optionB.order === 'undefined') {
    return -1;
  }
  if (typeof optionA.order === 'undefined' && typeof optionB.order !== 'undefined') {
    return 1;
  }
  if (
    (typeof optionA.order === 'undefined' && typeof optionB.order === 'undefined') ||
    optionA.order === optionB.order
  ) {
    if (optionA.label && optionB.label) {
      const labelA = optionA.label.toUpperCase();
      const labelB = optionB.label.toUpperCase();
      return labelA.localeCompare(labelB);
    }
  }
  return (optionA.order || 0) - (optionB.order || 0);
};

export default sortCheckboxOptions;
